<template>
    <a-row :gutter="24">
        <a-col :md="24">
            <a-card :bordered="false">
                <div class="trace-code-container">
                    <div v-if="currentStep === 0">
                        <!-- 展示追溯模版 -->
                        <div class="productBox">
                            <h3>产品信息</h3>
                            <a-row>
                                <a-col :md="8" class="productList">
                                    <span>名称：</span>
                                    <span>{{ productInfo.materialName }}</span>
                                </a-col>
                                <a-col :md="8">
                                    <span>编码：</span>
                                    <span>{{ productInfo.productNo }}</span>
                                </a-col>
                                <a-col :md="8">
                                    <span>型号：</span>
                                    <span>{{ productInfo.standard }}</span>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :md="8">
                                    <span>类别：</span>
                                    <span>{{ productInfo.categoryName }}</span>
                                </a-col>
                                <!-- <a-col :md="8">
                                    <span>单位：</span>
                                    <span>{{ productInfo.unit }}</span>
                                </a-col> -->
                                <a-col :md="8">
                                    <span>规格：</span>
                                    <span>{{ productInfo.model }}</span>
                                </a-col>
                            </a-row>
                        </div>
                        <TraceModule ref="traceModules" :traceVueModule="traceVueModule" @getDrawingList="handleGetDrawingList" :isStep="isStep"></TraceModule>
                        <div class="ensureBox">
                            <!-- <a-button type="primary" @click="handleSave">保存</a-button> -->
                            <a-button type="primary" @click="handleTraceSubmit" v-if="processCode == 'ZZ'">组装</a-button>
                            <a-button type="primary" @click="handleTracePrint" style="margin-left: 20px;" v-else-if="processCode == 'JY'">检验</a-button>
                        </div>
                        
                    </div>
                    <div v-else-if="currentStep === 1">
                        <div v-if="currentView === 'scan'">
                            <a-tabs default-active-key="1" @change="handleTabChange">
                                <a-tab-pane key="1" tab="扫码">
                                    <div class="scanBox">
                                    <a-button @click="handleScanStart" class="startScan">开始</a-button>
                                    <div class="scanContent">
                                        <a-list>
                                            <a-list-item v-for="(item, index) in scanData" :key="index">
                                                {{ index + 1 }}. {{ item }}
                                            </a-list-item>
                                        </a-list>
                                    </div>
                                    </div>
                                    <div class="ensureBox">
                                    <a-button type="primary" @click="handleScan">提交</a-button>
                                    </div>
                                </a-tab-pane>
                                <a-tab-pane key="2" tab="码段">
                                    <!-- 其他内容 -->
                                    <a-list>
                                        <a-list-item v-for="(item, index) in getProductCode" :key="index">
                                            {{ index + 1 }}. {{ item.idCode }}
                                        </a-list-item>
                                    </a-list>
                                    <div class="ensureBox">
                                        <a-button type="primary" @click="handleActive">码段提交</a-button>
                                    </div>
                                    <!-- 点击去激活按钮弹出modal，表单配置激活序号从哪到哪的码 -->
                                    <a-modal
                                        title="配置码段"
                                        :visible="activeVisible"
                                        @ok="handleActiveOk"
                                        @cancel="handleActiveCancel"
                                    >
                                        <a-form :form="activeForm">
                                            <a-form-item label="开始" name="startCode">
                                                <a-input v-model="activeForm.startCode" placeholder="请输入开始商品码" />
                                            </a-form-item>
                                            <a-form-item label="结束" name="endCode">
                                                <a-input v-model="activeForm.endCode" placeholder="请输入结束商品码" />
                                            </a-form-item>
                                        </a-form>
                                    </a-modal>
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                        <div v-else-if="currentView === 'print'">
                            <a-form-model ref="printForm" :model="printForm" :rules="rules" class="form-container">
                                <a-form-model-item 
                                    v-for="item in printItems" 
                                    :key="item.keyCode" 
                                    :label="item.keyType !== '6' && item.keyType !== '4' && item.keyType !== '5' ? item.keyName : ''" 
                                    :prop="item.keyCode" 
                                    class="form-item"
                                    
                                >
                                    <a-row :gutter="8">
                                        <a-col :span="24" :md="24">
                                            <template v-if="item.keyType === '0'">
                                                <a-input v-model="printForm[item.keyCode]" disabled/>
                                            </template>
                                            <template v-else-if="item.keyType === '1'">
                                                <!--  || item.keyType !== '5' -->
                                                <a-input v-model="printForm[item.keyCode]" />
                                            </template>
                                            <!-- <template v-else-if="item.keyType === '5'">
                                                <a-input v-model="printForm[item.keyCode]" />
                                            </template> -->
                                            <template v-else-if="item.keyType === '2'">
                                                <a-date-picker
                                                    v-model="printForm[item.keyCode]"
                                                    show-time
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    value-format="YYYY-MM-DD HH:mm:ss"
                                                />
                                            </template>
                                            <!-- <template v-else-if="item.keyType === '6'">
                                                <a-date-picker
                                                    v-model="printForm[item.keyCode]"
                                                    show-time
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    value-format="YYYY-MM-DD HH:mm:ss"
                                                />
                                            </template> -->
                                        </a-col>
                                    </a-row>
                                    <a-row v-if="item.keyType === '3'">
                                        <a-col :span="24">
                                            
                                            <a-select v-model="printForm[item.keyCode]" @change="handlePrintChange($event, item.keyCode)">
                                                <a-select-option
                                                    v-for="option in printOptions[item.keyCode]"
                                                    :key="option.dictValue"
                                                    :value="option.dictValue"
                                                    
                                                >
                                                    {{ option.dictLable }}
                                                </a-select-option>
                                            </a-select>
                                        </a-col>
                                    </a-row>     
                                    <a-row v-if="item.keyType === '4' && item.keyNodeCode !== 'CPGG'">
                                        <a-col :span="24">
                                            
                                            <a-select v-model="printForm[item.keyCode]" @change="handlePrintChange($event, item.keyCode)">
                                                <a-select-option
                                                    v-for="option in printOptions[item.keyCode]"
                                                    :key="option.dictValue"
                                                    :value="option.dictValue"
                                                    
                                                >
                                                    {{ option.dictLable }}
                                                </a-select-option>
                                            </a-select>
                                        </a-col>
                                    </a-row>                 
                                </a-form-model-item>
                                <!-- 添加固定的单选按钮 -->
                                <a-form-model-item label="数量" prop="fixedRadio" class="form-item">
                                    <a-radio-group v-model="printForm.fixedRadio" @change="handleRadioChange">
                                        <a-radio value="1">1</a-radio>
                                        <a-radio value="5">5</a-radio>
                                        <a-radio value="10">10</a-radio>
                                    </a-radio-group>
                                </a-form-model-item>
                            <a-form-model-item class="ensureBox">
                                <a-button type="primary" @click="handlePrint">检验</a-button>
                                <a-button type="primary" @click="handleEnd" style="margin-left: 10px">结束任务</a-button>
                            </a-form-model-item>
                        </a-form-model>
                        </div>
                    </div>
                    <!-- <div v-else-if="currentStep === 2">
                        <div class="completeBox">
                            <a-icon type="check-circle" style="color:#00DB00;font-size: 150px;display: block;width: 100%;"/>
                            <span class="completeText">{{completedInfo}}</span>
                        </div>
                        <div class="ensureBox">
                            <a-button type="primary" @click="handleCloseSteps">关闭</a-button>
                        </div>
                    </div> -->
                </div>
            </a-card>
        </a-col>
    </a-row>
</template>
<script>
    import { getCodeForm, getCodeFormDict, generateCodeByParameter, addPlan, getCodeSegmentList, getRuleMesByPlanId, getRuleMesByMaterialId, getAllModules, generateCodeForPrint, saveTempCode, traceSaveForPlanId, abandonTask } from '@/api/api'
    import {startPrint } from '@/views/UDIadmin/modules/allPrint'
    import TaskRunner from 'concurrent-tasks'
    import { getDI, getUserID } from '@/utils/auth.js';
    import TraceModule from '@/views/identifierCode/traceModule.vue';
    import moment from 'moment';
import { nextTick } from 'process'
    // import { traceSave } from '@/api/api'
    export default {
        name: 'VendorModal',
        props: {
            ruleId: {
                type: [String, Number],
                required: true
            },
            processId: {
                type: [String, Number],
                required: true
            },
            craftId: {
                type: [String, Number],
                required: true
            },
            metarialInfo: {
                type: [String, Number],
                required: true
            },
            planId: {
                type: [Number],
                required: true
            },
            processCode: {
                type: String,
                required: true
            },
            productInfo: {
                type: String,
                required: true
            },
        },
        components: {
            TraceModule
        },
        
        data(){
            return {
                form: { },
                printForm: { 
                    fixedRadio: '1' // 初始化固定单选按钮的值
                },
                activeForm: { },
                formData: { },
                rules: { },
                traceVueModule : null,
                currentView: 'scan', // 默认显示扫码内容
                textValue: '',
                number: '1',
                objectId: '',
                traceFormItems: [],
                formItems: [],
                printList: [],
                printItems: [],
                formOptions: {},// 修改为嵌套对象
                printOptions: {},// 修改为嵌套对象
                currentStep: 0, // 当前步骤
                stepFormItems: [], // 每个步骤的表单项
                templateData: [],
                traceFormItems: [], // 添加 traceFormItems 数组
                scanData: [],
                currentScan: '',
                isScanning: false,
                activeVisible: false,
                eventCodes: '',
                newItems: [],
                getProductCode: [],
                completedInfo: '完成',
                options: [],
                uploadUrl: process.env.VUE_APP_UPLOAD_URL,
                checkType: 1,
                getModuleInfo: {},
                formModule:[],
                traceModuleForm: {},
                isStep: 1, // 1表示模版管理配置模版显示全部；2表示从开始任务到配置模版只显示表单部分
                planRecordId: null,
                companyDI: '',
            }
        },
        computed: {
            currentFormItems() {
                return this.stepFormItems[this.currentStep] || [];
            },
            formattedValue() {
                return (vModel) => {
                    const item = this.traceFormItems.find(i => i.vModel === vModel);
                    if (item && item.value && item.tag === 'a-date-picker') {
                        return this.formatDate(item.value);
                    }
                    return item ? item.value : '';
                };
            }
        },
        beforeDestroy() {
            this.stopListeningForScan(); // 确保在组件销毁时移除事件监听器
        },
        
        methods: {
            // 获取未完成订单数据
            getCodeInfoForCookie(){
                console.log(this.processCode,'processCode===============999999999999999=========')
                if( this.planId == null || this.planId == '' || this.planId == undefined ){
                    this.getCodeInfo()
                    this.currentStep = 0
                } else {
                    // 当有计划id时，默认进入第二步
                    this.currentStep = 1
                    // 弹窗显示有未完成订单是否拉回订单
                    this.$confirm('检测到未完成订单，是否拉回?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        icon: null,
                        type: 'info'
                    }).then(() => {
                        this.planRecordId = this.planId
                        if( this.processCode == 'JY' ){
                            this.handleCookieTracePrint()
                            this.currentView = 'print'
                        } else if( this.processCode == 'ZZ' ){
                            this.currentView = 'scan'
                        }
                    }).catch(() => {
                        this.planRecordId = this.planId
                        abandonTask({planId: this.planRecordId})
                        .then(res => {
                            if ( res.code === 200 && res.success == true ) {
                                this.$message.success(res.message);
                                this.$emit('close')
                                // this.scanData = []
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    });
                    
                }
            },
            handleTabChange(checkType){
                this.checkType = checkType;
            },
            resetCurrentStep() {
                this.currentStep = 0;
                this.isStep = 1;
            },
            // 时间格式化
            formatDate(date) {
                if (!(date instanceof Date)) {
                    date = new Date(date);
                }
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },
             // 上传前的检查
            beforeUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('文件大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 处理文件上传
            handleChangeFile(info) {
                console.log(info,this.uploadUrl,'info==================')
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    this.$message.success(`${info.file.name} 文件上传成功`);
                    // 这里可以将文件信息保存到 formData 中
                    this.$set(this.traceFormItems, 'file', this.uploadUrl + '/download/h5template/' + info.file.response.result);
                    this.fileUrl = this.uploadUrl + '/download/h5template/' + info.file.response.result;
                    console.log('上传成功===============', this.traceFormItems);
                } else if (info.file.status === 'error') {
                    this.$message.error(`${info.file.name} 文件上传失败`);
                }
            },
            async getCodeInfo(){
                const params= {
                    ruleId: this.ruleId
                }
                const res = await getCodeForm(params)
                if( res.code === 200 && res.success === true ){
                    
                    if( res.result.params ){
                        this.ruleId = res.result.uuid
                        this.formItems = res.result.params;
                        // 初始化 stepFormItems
                        this.initStepFormItems();
                        // 初始化 form 和 rules
                        this.formItems.forEach(item => {
                            if (item.keyType !== '6' || item.keyType !== '5') {
                                this.$set(this.form, item.keyCode, item.keyValue || '');

                                // 根据 keyType 设置验证规则
                                switch (item.keyType) {
                                    case '0': // 常量
                                    case '1': // 变量
                                    // case '5': // 序列号
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'blur' }];
                                    //     break;
                                    // case '2': // 日期
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                    //     break;
                                    case '3': // 标准字典
                                    // case '4': // 自定义字典
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                    //     this.getOptions(item.keyDescription.dicCode, item.keyCode); // 调用 getOptions 并传递 keyCode
                                    //     break;
                                    // case '6': // 当前日期
                                    //     this.rules[item.keyCode] = [];
                                    //     break;
                                    default:
                                        break;
                                }
                            }
                        });
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    this.$message.error('获取数据失败')
                    console.log(this.formItems,'this.formItems还有值吗？？？？？？？？？？')
                    this.formItems = []
                }
                this.submitGenerateCode()
            },
            initStepFormItems() {
                // 假设 formItems 已经按照步骤划分好
                this.stepFormItems = [
                    this.formItems.slice(0, 3), // 第一步的表单项
                    this.formItems.slice(3, 6), // 第二步的表单项
                    this.formItems.slice(6)    // 第三步的表单项
                ];
            },
            async getOptions(dicCode, keyCode) {
                // 根据 keyType 返回相应的选项
                const res = await getCodeFormDict({dictId: dicCode})
                // 把res的值赋给select
                if( res.code === 200 && res.success === true ){
                    this.$set(this.formOptions, keyCode, res.result);
                    this.$set(this.printOptions, keyCode, res.result);
                }
            },
            getCurrentDate() {
                return new Date().toISOString().split('T')[0];
            },
            // 切换获取select选中值
            handleChange(value, keyCode) {
                // 找到对应的 option 对象
                const selectedOption = this.formOptions[keyCode].find(option => option.dictValue === value);
                if (selectedOption) {
                    // 遍历 formItems，将选中的值赋给对应的 keyCode 对应的 key
                    this.formItems.forEach(item => {
                        if (item.keyCode === keyCode) {
                            item.keyDescription.itemValue = selectedOption.dictLable;
                            item.keyDescription.itemCode = selectedOption.uuid
                            item.keyValue = value
                        }
                    });
                }
            },
            handlePrintChange(value, keyCode) {
                // 找到对应的 option 对象
                const selectedOption = this.printOptions[keyCode].find(option => option.dictValue === value);
                if (selectedOption) {
                    // 遍历 formItems，将选中的值赋给对应的 keyCode 对应的 key
                    this.printItems.forEach(item => {
                        if (item.keyCode === keyCode) {
                            item.keyDescription.itemValue = selectedOption.dictLable;
                            item.keyDescription.itemCode = selectedOption.uuid
                            item.keyValue = value
                        }
                    });
                }
            },
            // 结束任务
            handleEnd(){
                this.saveData()
            },
            // 开始扫码
            handleScanStart(){
                if (!this.isScanning) {
                    this.isScanning = true;
                    this.currentScan = ''; // 清空当前累积的数据
                    window.addEventListener('keydown', this.handleKeyPress);
                }
            },
            // 重新开始扫码
            handleScanRestart() {
                if (!this.isScanning) {
                    this.isScanning = true;
                    this.currentScan = ''; // 清空当前累积的数据
                    window.addEventListener('keydown', this.handleKeyPress);
                }
            },
            handleKeyPress(event) {
                if (!this.isScanning) return;

                // 捕获扫码数据
                const key = event.key;
                console.log(key, '扫码数据');
                // 忽略 Shift 键
                if (key.toLowerCase() === 'shift') {
                    return;
                }
                // 忽略F12和ControlInsert 
                if (key === 'F12' || key === 'ControlInsert') {
                    return;
                }
                // 假设扫码结束符是回车键
                if( key === 'Enter' ){
                    this.isScanning = false;
                    window.removeEventListener('keydown', this.handleKeyPress);
                    if ( this.currentScan !== '' ){
                        const isExist = this.scanData.some(item => item === this.currentScan.trim());
                        const rootNode = getDI()
                        // 是否以rootNode开头
                        const isStartWithRootNode = this.currentScan.trim().startsWith(rootNode);
                        console.log(rootNode,'rootNode=======================')
                        if (isExist) {
                            this.$message.error('重复');
                            this.currentScan = ''; // 清空当前累积的数据
                            this.handleScanRestart(); // 重新开始监听键盘事件
                            return;
                        } else {
                            if ( isStartWithRootNode ){
                                this.saveCode(this.currentScan)
                            } else {
                                this.$message.error('码错误，请重新扫码~');
                                this.currentScan = ''; // 清空当前累积的数据
                                this.handleScanRestart(); // 重新开始监听键盘事件
                            }
                            
                        }
                    } else {
                        return;
                    }
                    // this.handleScanComplete(); // 新增方法，处理扫描完成后的逻辑
                    
                } else {
                    // this.currentScan += key;
                    if (key.length === 1 && key !== 'Unidentified') {
                        this.currentScan += key;
                    }
                    console.log(this.currentScan,'this.currentScan==============')
                }
            },
            handleScanComplete() {
                // 重新开始监听键盘事件
                this.isScanning = true;
                window.addEventListener('keydown', this.handleKeyPress);
            },
            async saveCode(e){
                const params = { 
                    objectCode: e,
                    planRecordId: this.planRecordId,
                }

                saveTempCode(params).then(res => {
                    if (res.code === 200 && res.success === true) {
                        this.$message.success(res.message);
                        this.scanData.push(e.trim());
                        this.currentScan = ''; // 清空当前累积的数据
                        this.handleScanRestart(); // 重新开始监听键盘事件
                    } else {
                        this.$message.error(res.message);
                        this.currentScan = ''; // 清空当前累积的数据
                        this.handleScanRestart(); // 重新开始监听键盘事件
                    }
                })
                },
            // 生码提交
            // handleSubmit(){
            //     this.$refs.form.validate(valid => {
            //         if (valid) {
            //             this.submitGenerateCode();
            //         } else {
            //             console.log('表单验证失败');
            //             return false;
            //         }
            //     });
            // },
            async submitGenerateCode(){
                const params = {
                    params: JSON.stringify(this.formItems),
                    ruleId: this.ruleId,
                    processId: this.processId
                }
                const res = await generateCodeByParameter(params)
                console.log(res,'生码结果===============')
                if( res.code === 200 && res.success == true ){
                    // this.$message.success('生码成功')
                    console.log(res.result,'res.result===============')
                    this.eventCodes = res.result.code
                    this.currentStep = 0;
                    this.isStep = 2;
                    this.traceVueModule = res.result.templateData
                    console.log(typeof(this.traceVueModule),this.traceVueModule,'this.traceVueModule===============')
                    this.templateData = res.result.templateData
                    this.traceFormItems = res.result.templateData
                    console.log(this.traceFormItems,'formData121212=================')
                } else {
                    this.$message.error(res.result.records)
                }
            },
            // 处理接收的数据
            handleGetDrawingList(drawingList){
                console.log(drawingList,'drawingList===============')
            },
            // 追溯模版确认提交
            handleTraceSubmit(){
                this.currentView = 'scan';
                // 调用子组件的save方法
                this.$refs.traceModules.save();
                // 获取traceFormItems的label
                console.log(this.traceFormItems,'this.formData===========')
                if( this.traceFormItems !== '' || this.traceFormItems !== null ){
                    // 遍历 this.traceFormItems 并更新每个表单项的 value
                    this.traceFormItems = this.traceFormItems.map(item => {
                        let value = this.traceFormItems[item.vModel] || '';
                        // 检查 value 是否为 Date 类型
                        if (value instanceof Date) {
                            // 使用 moment.js 格式化日期
                            value = moment(value).format('YYYY-MM-DD HH:mm:ss');
                        }
                        // 如果 是文件对象，把traceFormItems.file值赋给对应的item的value
                        
                        if (item.name  == 'file') {
                            value = this.fileUrl
                        }
                        return {
                            ...item,
                            value: value
                        }
                    });
                    console.log(this.traceFormItems,'55555formData=================')
                    localStorage.setItem('traceFormItems', JSON.stringify(this.traceFormItems))
                    this.currentStep = 1
                    this.handleSave()
                    this.getCodeSegmentList()
                } else {
                    this.currentStep = 1
                    this.handleSave()
                    this.getCodeSegmentList()
                }
                
            },
            async saveData(){
                const params = { 
                    planId: this.planRecordId,
                    checkType: this.checkType,
                    startCode: this.activeForm.startCode == '' || this.activeForm.startCode == null || this.activeForm.startCode == undefined ? '' : this.activeForm.startCode.trim(),
                    endCode: this.activeForm.endCode == '' || this.activeForm.endCode == null || this.activeForm.endCode == undefined  ? '' : this.activeForm.endCode.trim(),
                    saveType : 1 // 1保存追溯平台 2保存本地
                }
                const res = await traceSaveForPlanId(params)
                if (res.code === 200 && res.success == true ) {
                    this.$message.success(res.result);
                    this.visible = false;
                    this.$emit('close')
                    this.scanData = []
                } else {
                    this.$message.error(res.result);
                }
            },
            async handleSave(){
                const operatorTime = new Date().getTime()
                const planDate = moment(operatorTime).format('YYYY-MM-DD HH:mm:ss');
                const params = {
                    craftId: this.craftId,
                    traceCode: this.eventCodes,
                    materialId: this.metarialInfo,
                    planDate: planDate,
                    procSeq: this.procSeq,
                    processId: this.processId,
                    formData: this.traceFormItems
                }
                const res = await addPlan(params)
                if( res.code === 200 && res.success == true ){
                    // this.$message.success(res.message)
                    this.planRecordId = res.result.id
                    this.currentStep = 1
                    this.activeVisible = false
                } else {
                    this.$message.error(res.message)
                }
            },
            handleRadioChange(event){
                console.log('Selected radio value:', event.target.value);
                this.number = event.target.value
            },
            // 去打印==获取表单信息
            async handleTracePrint(){
                this.currentView = 'print';
                this.currentStep = 1
                const params = {
                    materialId: this.metarialInfo,
                } 
                const res = await getRuleMesByMaterialId(params)
                console.log(res,'码段列表===============')
                if( res.code == 200 && res.success == true ){
                    // this.getProductCode = res.result.records
                    this.objectId = res.result.uuid
                    this.printItems = res.result.params;
                        // 初始化 stepFormItems
                        this.initStepPrintItems();
                        // 初始化 form 和 rules
                        this.printItems.forEach(item => {
                            if (item.keyType !== '6' || item.keyType !== '5') {
                                this.$set(this.printForm, item.keyCode, item.keyValue || '');

                                // 根据 keyType 设置验证规则
                                switch (item.keyType) {
                                    case '0': // 常量
                                    case '1': // 变量
                                    // case '5': // 序列号
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'blur' }];
                                    //     break;
                                    // case '2': // 日期
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                    //     break;
                                    case '3': // 标准字典
                                    // case '4': // 自定义字典
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                    //     this.getOptions(item.keyDescription.dicCode, item.keyCode); // 调用 getOptions 并传递 keyCode
                                    //     break;
                                    case '6': // 当前日期
                                        this.rules[item.keyCode] = [];
                                        break;
                                    default:
                                        break;
                                }
                                // if ( item.keyType === '5' ){
                                //     item.keyName = '打印个数'
                                // }
                            }
                        });
                    

                } else {
                    this.$message.error(res.message)
                }
                this.handleSave()
            },
            // 获取缓存数据获取表单信息
            async handleCookieTracePrint(){
                this.currentView = 'print';
                this.currentStep = 1
                const params = {
                    materialId: this.metarialInfo,
                } 
                const res = await getRuleMesByMaterialId(params)
                console.log(res,'码段列表===============')
                if( res.code == 200 && res.success == true ){
                    // this.getProductCode = res.result.records
                    this.objectId = res.result.uuid
                    this.printItems = res.result.params;
                        // 初始化 stepFormItems
                        this.initStepPrintItems();
                        // 初始化 form 和 rules
                        this.printItems.forEach(item => {
                            if (item.keyType !== '6' || item.keyType !== '5') {
                                this.$set(this.printForm, item.keyCode, item.keyValue || '');

                                // 根据 keyType 设置验证规则
                                switch (item.keyType) {
                                    case '0': // 常量
                                    case '1': // 变量
                                    // case '5': // 序列号
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'blur' }];
                                    //     break;
                                    // case '2': // 日期
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                    //     break;
                                    case '3': // 标准字典
                                    // case '4': // 自定义字典
                                    //     this.rules[item.keyCode] = [{ required: true, message: `${item.keyName}不能为空`, trigger: 'change' }];
                                    //     this.getOptions(item.keyDescription.dicCode, item.keyCode); // 调用 getOptions 并传递 keyCode
                                    //     break;
                                    case '6': // 当前日期
                                        this.rules[item.keyCode] = [];
                                        break;
                                    default:
                                        break;
                                }
                                // if ( item.keyType === '5' ){
                                //     item.keyName = '打印个数'
                                // }
                            }
                        });
                    

                } else {
                    this.$message.error(res.message)
                }
            },
            initStepPrintItems(){
                
            },
            handlePrint(){
                this.$refs.printForm.validate(valid => {
                    if (valid) {
                        // 遍历 printItems 并更新每个表单项的 value
                        this.printItems = this.printItems.map(item => {
                            let value = this.printForm[item.keyCode] || '';
                            if (moment.isMoment(value)) {
                                // 使用 moment.js 格式化日期
                                value = value.format('YYYY-MM-DD HH:mm:ss');
                                } else if (value instanceof Date) {
                                // 如果 value 是 Date 对象，使用 moment.js 格式化日期
                                value = moment(value).format('YYYY-MM-DD HH:mm:ss');
                                } else if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                                // 如果 value 是类似 '2025-01-15' 的字符串，添加时间部分
                                value = moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss');
                                }
                            return {
                                ...item,
                                keyValue: value
                            };
                        });
                        console.log(this.printItems, 'printItems after submit=================');
                        // this.params = this.printItems.map(item => ({
                        //     keyName: item.keyName,
                        //     keyValue: item.keyValue,

                        // }));
                        // 这里可以处理打印逻辑
                        // this.currentStep = 0;
                        this.getGenerateCodeForPrint()
                        // this.getAllModules() // 获取所有模版信息
                    } else {
                        console.log('表单验证失败');
                        return false;
                    }
                });
            },
            // 获取所有产品列表
            async getGenerateCodeForPrint(){
                const params = {
                    // ruleId: this.ruleId,
                    ruleId: this.objectId,
                    number: this.number,
                    planId: this.planRecordId,
                    params: JSON.stringify(this.printItems)
                }
                const res = await generateCodeForPrint(params)
                if( res.code == 200 && res.success == true ){
                    // this.getModuleInfo.forEach(item => {
                    //     item.code = res.result.code
                    //     item.codeList = res.result.codeList
                    // })
                    this.printList = res.result
                    this.getAllModules() 
                    console.log(res.result,'获取的============产品列表===============')
                } else {
                    this.$message.error(res.message)
                }
            },
            // 获取所有模版信息
            async getAllModules(){
                const res = await getAllModules()
                console.log(res,'获取的============模版列表===============')
                // 根据uuid  106c9a658773405f88795675ad9bc897值去查res.data里返回的列表，获取出uuid=106c9a658773405f88795675ad9bc897的所有数据
                if( res.code == 200 && res.success == true ){
                    this.getModuleInfo = res.result.filter(item => item.uuid === '106c9a658773405f88795675ad9bc897')
                    console.log(this.getModuleInfo,'获取的============模版列表===============')
                    // startPrint(this.printList, this.getModuleInfo, this.number,doneApi,runner,{pageNumber:i,limit})

                    // 确保在获取到模版信息后调用 startPrint 方法
                    if ( this.printList && this.getModuleInfo ) {
                        const runner = new TaskRunner();
                        runner.setConcurrency(1);
                        const tasks = [];
                        const limit = 500;
                        const pageNumber = Math.ceil(this.printList.length / limit);

                        for (let i = 1; i <= pageNumber; i++) {
                            tasks.push(async (doneApi) => {
                            try {
                                const beginNumber = (i - 1) * limit;
                                const endNumber = i * limit;
                                const pagePrintList = this.printList.slice(beginNumber, endNumber);
                                // 获取的打印列表this.printList
                                // 获取的打印模版信息this.getModuleInfo
                                // 打印数量this.n umber
                                const copies = 1
                                startPrint(this.printList, this.getModuleInfo[0], copies, doneApi, runner, { pageNumber: i, limit });
                            } catch (error) {
                                this.$message.error('打印失败: ' + error.message);
                                console.log(error.message,'error.message================')
                                doneApi(); // 确保任务完成
                            }
                            });
                        }

                        runner.addMultiple(tasks);
                    }

                } else {
                    this.$message.error('获取模版列表失败')
                }
            },
            // 获取码段列表
            async getCodeSegmentList(){
                const params = {
                    materialId: this.metarialInfo,
                    processId: this.processId, // 工序ID
                    craftlId: this.craftId,
                    pageSize: 10,
                    currentPage: 1
                }
                const res = await getCodeSegmentList(params)
                console.log(res,'码段列表===============')
                if( res.code == 200 && res.success == true ){
                    this.getProductCode = res.result.records
                } else {
                    this.$message.error('获取码段列表失败')
                }
                
            },
            // 第三部提交
            handleScan(){
                this.newItems = this.flattenItems(this.traceFormItems);
                this.submit()
                console.log(this.newItems,'提交数据==============')
                // this.newItems = this.traceFormItems.map(item => {
                //     return {
                //         name: item.label,
                //         code: item.vModel,
                //         value: item.defaultValue
                //     };
                // });
                
            },
            flattenItems(items) {
                let result = [];
                items.forEach(item => {
                // 创建当前 item 的对象
                result.push({
                    name: item.label,
                    code: item.vModel,
                    value: item.defaultValue,
                    options: item.options
                });

                // 如果 item 包含 children，则递归处理 children
                if (item.children && item.children.length > 0) {
                    result = result.concat(this.flattenItems(item.children));
                }
                });
                return result;
            },
            submit(){
                const operatorTime = new Date().getTime()
                const operatorTimeStr = moment(operatorTime).format('YYYY-MM-DD HH:mm:ss');
                const params = {
                    craftId: this.craftId,
                    eventCode: this.eventCodes, // 事件编码
                    formData: this.newItems,
                    objectCodes: this.scanData, // 追溯码列表
                    operatorTime: operatorTimeStr, //操作时间
                    materialId: this.metarialInfo,
                    processId: this.processId,
                    checkType: this.checkType,
                    startCode: this.activeForm.startCode == '' || this.activeForm.startCode == null || this.activeForm.startCode == undefined ? '' : this.activeForm.startCode.trim(),
                    endCode: this.activeForm.endCode == '' || this.activeForm.endCode == null || this.activeForm.endCode == undefined ? '' : this.activeForm.endCode.trim(),
                    personCode: 'MA.M9.166.3546769.DCJ0001-S003', //人员码',
                    planId: this.planRecordId

                }
                traceSaveForPlanId(params).then(res => {
                    console.log(res,'res==============')
                    if( res.code == 200 && res.success == true ){
                        this.$message.success(res.message)
                        this.currentStep = 0
                        // 关闭父组件的modal
                        this.$emit('close')
                        this.planRecordId = ''
                        this.scanData = []
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            handleCloseSteps(){
                
                // 关闭父组件的modal
                this.$emit('close')
                this.currentStep = 0
            },
            handleActive(){
                this.activeVisible = true
            },
            handleActiveOk(){
                this.activeVisible = false
                this.handleScan()
            },
            handleActiveCancel(){
                this.activeVisible = false
            },
            // 提交需要激活的码段
            submitActive(){

            }
        }
    }                                           
</script>
<style lang="less" scoped>
    .form-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .form-item {
            width: 49%;
        }
    }
    .traceForm-container{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .ant-form-item {
            width: 100%;
        }
    }
    .ensureBox {
        display: inline-block;
        width: 100%;
        justify-content: flex-end;
        border-top: 1px solid #e6e6e6;
        padding-top: 10px;
        margin-top: 10px;
    }
    .scanContent {
        padding: 20px 38px;
    }
    .startScan {
        margin: 20px 20px 10px 38px;
    }
    .completeBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 160px 0 30px 0;
        .completeText {
            width: 100%;
            text-align: center;
            font-size: 20px;
            margin-top: 30px;
        }
    }
    .productBox {
        background-color: #f0f2f5;
        margin-bottom: 10px;
        padding: 20px;
        border-radius: 10px 10px 0 0;
        border: 1px solid #e6e6e6;
        h3 {
            color: #1890ff;
            border-left: 4px solid #1890ff;
            line-height: 22px;
            margin-bottom: 10px;
            padding-left: 10px;
        }
        .productList {
            margin-bottom: 10px;
        }
    }
</style>
